import { render } from "./IOSFestflight.vue?vue&type=template&id=8050c1f2"
import script from "./IOSFestflight.vue?vue&type=script&lang=js"
export * from "./IOSFestflight.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/goj/vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__